const C = {
  name: "Triangle",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 4C11.7304 4 11.4814 4.14573 11.3532 4.36488L11.3472 4.3751L3.36954 17.6511C3.13004 18.0589 3 18.5326 3 19C3 19.5477 3.45228 20 4 20H20C20.5477 20 21 19.5477 21 19C21 18.5304 20.869 18.0633 20.6294 17.6758L20.6223 17.6644L12.6468 4.36491C12.5186 4.14576 12.2696 4 12 4ZM9.63014 3.34944C10.1227 2.51195 11.0318 2 12 2C12.9683 2 13.8776 2.51213 14.3701 3.34986L22.3343 16.6303C22.7723 17.3414 23 18.172 23 19C23 20.6523 21.6523 22 20 22H4C2.34772 22 1 20.6523 1 19C1 18.1687 1.22923 17.3437 1.64846 16.6323L1.65282 16.6249L9.63014 3.34944Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Triangle
};
